var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('Row',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }